import { Query } from '../../_base/actionBus/Query';
import { Claim } from '../../models/claims/Claim';

export class GetUnitClaims extends Query<Claim[]> {}